import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
export function ScarcityBar() {
  const [spotsLeft, setSpotsLeft] = useState(23);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(prev => prev <= 9 ? 23 : prev - 1);
    }, 24000);
    return () => window.clearInterval(id);
  }, []);
  const percentage = Math.max(6, Math.round(spotsLeft / 200 * 100));
  return <div className="w-full rounded-2xl border border-ofm-200 bg-white p-4 shadow-sm sm:p-5" data-id="element-238" data-mp="2b5p024n2d00z">
      <div className="flex items-start gap-2" data-id="element-239" data-mp="2g6w9e84uu79r">
        <FlameIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#D93A2B]" aria-hidden="true" data-id="element-240" data-mp="2g3gt51zg2s6r" />
        <p className="text-[13px] font-bold leading-snug text-ofm-900 sm:text-[15px]" data-id="element-241" data-mp="22850d04unbsh">
          Solo quedan{' '}
          <span className="text-[#D93A2B]" data-id="element-242" data-mp="276zpejtetwl1">{spotsLeft} cupos</span> con el precio
          promocional de $12.99 USD
        </p>
      </div>

      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-ofm-100" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={100 - percentage} aria-label="Cupos promocionales ocupados" data-id="element-243" data-mp="5cqqghiptk5t">
        <div className="h-full rounded-full bg-[#D93A2B] transition-all duration-700" style={{
        width: `${100 - percentage}%`
      }} data-id="element-244" data-mp="3dces5w5v5h3r" />
      </div>

      <p className="mt-2 text-[11px] font-medium text-ofm-800/60 sm:text-xs" data-id="element-245" data-mp="38foc38u26lic">
        {100 - percentage}% de los cupos promocionales ya fueron reclamados hoy.
      </p>
    </div>;
}